export default {
  gap: 50,
  filterThickness: 40,
  filterLength: 150,
  twoRows: true,
};
